<template>
  <p>Account Profile</p>
</template>

<script>
export default {
  name: 'Profile'
};
</script>
